import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const frontendToken = import.meta.env.VITE_FRONTEND_TOKEN;
    if (frontendToken) {
      config.headers['X-Frontend-Token'] = frontendToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't retried the request yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const response = await instance.post('/auth/refresh-token', { refreshToken });
        
        const { token } = response.data;
        localStorage.setItem('token', token);

        originalRequest.headers.Authorization = `Bearer ${token}`;
        return instance(originalRequest);
      } catch (error) {
        const wasLoggedIn = !!localStorage.getItem('token');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        // Prompt re-login in-app instead of redirecting to a nonexistent /login route
        if (wasLoggedIn) {
          window.dispatchEvent(new Event('auth:session-expired'));
        }
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;